import Typography from "@mui/material/Typography";

export default function Titulo({ label, align, children = "", className, color, sx }) {
  return (
    <Typography className={className} textAlign={align} color={color} sx={sx} variant="h5">
      {label ?? children}
    </Typography>
  );
}
